import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/svg/calendar.svg'


const _hoisted_1 = { class: "flex flex-row items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center border-gray-lp-400 border focus:shadow py-1.8 px-2.5 flex items-center",
  style: {"height":"2.435rem","margin-right":"-1px"}
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "calendar"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateTimeInput = _resolveComponent("DateTimeInput")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("input", {
        "data-testid": _ctx.dataTestid,
        type: "text",
        readonly: "",
        disabled: _ctx.disabled,
        value: _ctx.displayValue,
        placeholder: _ctx.placeholder,
        class: ["px-3 text-14px rounded-r-md border-l border-r border-t border-b border-gray-lp-400 bg-white text-black-lp-300 focus:outline-none focus:shadow w-full", 
          _ctx.disabled ? 'text-gray-lp-600 bg-gray-lp-1200 cursor-not-allowed' : 'cursor-pointer'
        ],
        style: {"height":"2.435rem"},
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
      }, null, 42, ["data-testid", "disabled", "value", "placeholder"])
    ]),
    _createVNode(_component_DateTimeInput, {
      modelValue: _ctx.modelValue,
      isVisible: _ctx.isModalVisible,
      title: _ctx.title,
      minDate: _ctx.minDate,
      validateTodayMinHour: _ctx.validateTodayMinHour,
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isModalVisible = $event)),
      "onUpdate:modelValue": _ctx.onUpdateModelValue
    }, null, 8, ["modelValue", "isVisible", "title", "minDate", "validateTodayMinHour", "onUpdate:modelValue"])
  ]))
}